import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { FileValueAccessor } from './file-value-accessor';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormlyMatFormFieldModule } from '@ngx-formly/material/form-field';

@Component({
  selector: 'formly-field-file',
  template: ` <input type="file" [formControl]="formControl" [formlyAttributes]="field" /> `,
  standalone:true,
  imports: [FormlyModule, ReactiveFormsModule, FileValueAccessor, MatFormFieldModule, FormlyMatFormFieldModule  ]

})
export class FormlyFieldFile extends FieldType<FieldTypeConfig> {}
